<polygon id="polygon-{id}" {...data} />

<script>export let id;
export let data = {};
</script>
